import Vue from 'vue';

// local state
const getDefaultState = () => {
    return {
        value: {
            project: false,
        },
    }
};

const state = getDefaultState()

const getters = {

};

const mutations = {
    updateValidation(state, value) {
        state.value = value
    },
    resetState(state) {
        Object.assign(state, getDefaultState())
    }
};

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};